import { typeCreatorV2 } from '../../utils/common';

//  [REDUCER][TYPE]
export const SET_MESSAGE_INCOMING_LIST: string = typeCreatorV2(
  'MessageIncomingReducer',
  'SetMessageIncomingList'
);

export const SET_MEMBER_STATE_EXCLUDE_CYPRUS: string = typeCreatorV2(
  'MessageIncomingReducer',
  'SetMemberStateCountriesExcludeCyprus'
);

export const GET_MESSAGE_INCOMING_XML: string = typeCreatorV2(
  'MessageIncomingReducer',
  'GetMessageIncomingXml'
);
